module.exports = {
  onelink_id: '2279859408',
  media_source: 'e8bc13ad',
};
